import { Stage } from '@eventbrite/webapp-constants';

export const PROJECT_NAME = 'valkyrie';
export const RESOURCE_NAME = 'listings-webapp';

export const LISTING_FIRST_HIERARCHY_LEVEL_EXPERIMENT = {
  experimentName: 'listing_first_hierarchy_level',
  param: 'show_first_hierarchy_level',
  defaultValue: false,
};

export const QUERY_PARAMS = {
  FORCE_ERROR: 'force-error',
  AFFILIATE_CODE: 'aff',
  WAITLIST_TOKEN: 'w',
};

export const CORE_HOSTS: Record<Stage, string> = {
  [Stage.LOCAL]: 'localhost',
  [Stage.DEV]: 'evbdev.com',
  [Stage.TEST]: 'evbqa.com',
  [Stage.PROD]: 'eventbrite.com',
};

export const DEV_STAGES = [Stage.LOCAL, Stage.DEV];

// This is a blocklist for excluding high profile organizers who do
// not want the get_related_events feature shown on their listings
// This list can also be found in https://github.com/eventbrite/search_service/blob/main/search_service/common/constants/get_related_events_blocklist.py#L17
// The idea is to use this list sparingly and only for high profile organizers who specifically request for it.
export const ORGANIZERIDS_EXCLUDE: Record<Stage, string[]> = {
  [Stage.PROD]: [
    '64445481493', // added 20230628 'Moses Lake Temple' orgid=1503802633323
    '23418369060', // added 20230718 'Ted Macaluso' orgid=309966940785 EB-225728
    '66927575373', // added 20230718 'Temple Department' CoLDS orgid=1551159597713 EB-225728
    '65797691163', // added 20230829 'the-utah-area-ysa' CoLDS orgid=1551159597713 EB-225728
    '71080805893', // added 20231204 'Intermountain...' orgid=1758676397673 EB-237360
    '29446193521', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '33640155177', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '29697999913', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '76802821573', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '51878695483', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '75120839543', // added 20240131 'VIP Nightlife' orgid=401761939085 EB-243516
    '70095385903', // added 20240805 'PADI AMERICAS' orgid=1722850217693 EB-257583
    '71641241673', // added 20240805 'PADI Asia Pacific Instructor Development' orgid=1776943206483 EB-257583
    '87780843543', // added 20240805 'Cosmo Prof' orgid=2218556823153 EB-257583
  ],
  [Stage.TEST]: [],
  [Stage.DEV]: [],
  [Stage.LOCAL]: [],
};

export const PRIVATE_ORG_DIVISOR = 1007;